import { React, useState, useEffect } from "react";
//import {isMobile} from 'react-device-detect';
const BetfairCasinoBetslipWeb = ({
  showBetSlip,
  placeBetObject,
  closeBetSlipParent,
  placeBetParent,
  betErrorMessageObj,
  stakeList,
  loading
}) => {
  /*console.log(showBetSlip);
    console.log(placeBetObject);*/

  const [stakeValue, setBetfairStakeValue] = useState({ value: "" });
  const [showBetfairProfitLossCalculation, setBetfairProfitLossCalculation] =
    useState(false);
  const [liability, setLiabilityValue] = useState(0);
  const [profit, setProfitValue] = useState(0);
  const [betErrorMessage, setBetErrorMessage] = useState("");
  const [betButtonShowLoaderShow, setButtonShowLoaderShow] = useState(false);
  const [defaultAmount, setDefaultAmount] = useState("");

  let stake1 = 100;
  let stake2 = 200;
  let stake3 = 500;
  let stake4 = 1000;

  let stake5 = 5000;
  let stake6 = 10000;
  let stake7 = 20000;
  let stake8 = 50000;

  if (
    stakeList !== undefined &&
    stakeList !== null &&
    stakeList !== "" &&
    stakeList.stake1 !== undefined &&
    stakeList.stake1 !== null
  ) {
    stake1 = stakeList.stake1;
    stake2 = stakeList.stake2;
    stake3 = stakeList.stake3;
    stake4 = stakeList.stake4;

    stake5 = stakeList.stake5;
    stake6 = stakeList.stake6;
    stake7 = stakeList.stake7;
    stake8 = stakeList.stake8;
  }

  /*let betSlipDisplayStatus = false; 
   let isMobile = false;
   if(showBetSlip){
      //if(placeBetObject!=null && placeBetObject!="" && placeBetObject.bettype!=undefined) {
         console.log(isMobile);
            if(isMobile==false) {
               betSlipDisplayStatus = true;  
            } 
      //}
   }*/

  const getTypeAmount = (amount) => {
    amount = Number(amount);
    setDefaultAmount(amount);
  };

  const setStake = (value) => {
    if (defaultAmount > 0) {
      let newValue = Number(defaultAmount) + Number(value);
      setDefaultAmount(newValue);
    } else {
      setDefaultAmount(value);
    }

    /*if(stakeValue.value>0) {
         let newValue = (stakeValue.value+value); 
         setBetfairStakeValue({value:newValue});
      } else {
         setBetfairStakeValue({value});
      }*/
  };

  useEffect(() => {
    if (defaultAmount > 0) {
      setProfitLoss();
    }
  }, [defaultAmount]);

  const setProfitLoss = () => {
    if (placeBetObject.bettype == "b") {
      let liveRate = placeBetObject.odds;
      if (liveRate > 0) {
        let liabilityNew = defaultAmount;
        setLiabilityValue(liabilityNew);

        let profitNew = Math.round(liveRate * liabilityNew - liabilityNew);
        setProfitValue(profitNew);
        setBetfairProfitLossCalculation(true);
      }
    } else {
      let liveRate = placeBetObject.odds;
      if (liveRate > 0) {
        let profitNew = defaultAmount;
        setProfitValue(profitNew);

        let liabilityNew = Math.round(liveRate * profitNew - profitNew);
        setLiabilityValue(liabilityNew);
        setBetfairProfitLossCalculation(true);
      }
    }
  };

  const closeBetSlip = () => {
    //betSlipDisplayStatus = false;
    //setBetfairStakeValue({ value: "", type: "" });
    setDefaultAmount("");
    setLiabilityValue(0);
    setProfitValue(0);
    closeBetSlipParent();
    setBetErrorMessage("");
    setBetfairProfitLossCalculation(false);
  };

  const clearStake = () => {
    //setBetfairStakeValue({ value: "", type: "" });
    setDefaultAmount("");
    setLiabilityValue(0);
    setProfitValue(0);
    setBetErrorMessage("");
    setBetfairProfitLossCalculation(false);
    //clearBetSlipParent();
  };

  const place_bet = () => {
    //const intervalId = setInterval(() => {
    if (defaultAmount > 0) {
      setBetErrorMessage("");
      setButtonShowLoaderShow(true);
      //setBetButtonShow(false);
      placeBetParent(defaultAmount, profit);
      //clearInterval(intervalId);
    }
    //}, 10000); // 1 second
  };

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };

  useEffect(() => {
    if (betErrorMessageObj !== null && betErrorMessageObj !== undefined) {
      if (
        betErrorMessageObj.status !== null &&
        betErrorMessageObj.status !== undefined
      ) {
        if (betErrorMessageObj.status) {
          setBetErrorMessage("");
          closeBetSlip();
          setButtonShowLoaderShow(false);
          //setBetButtonShow(true);
          //betSlipDisplayStatus = false;
        } else {
          setButtonShowLoaderShow(false);
          //setBetButtonShow(true);
          setBetErrorMessage(betErrorMessageObj.message);
        }
      }
    }
  }, [betErrorMessageObj]);

  return (
    <div
      id="casinoBetslipWeb"
      className="bets mob-hide"
      style={{ display: showBetSlip == true ? "block" : "none" }}
    >
      <strong>Bet Slip </strong>
      <div className="betting-table">
        <table className="table">
          <thead>
            <tr>
              <th>Bet for</th>
              <th>Odds</th>
              <th>Stake</th>
              <th>Profit</th>
            </tr>
          </thead>
          <tbody>
            <tr
              className=" bgColorBetslip"
              style={{
                background:
                  placeBetObject.bettype === "b" ||
                  placeBetObject.bettype === "B"
                    ? "var(--theme-bg-color)"
                    : "#fce3e4"
              }}
            >
              <td>
                <span id="divteamname_casino_web">
                  {placeBetObject.teamname}
                </span>
              </td>
              <td width="10%">
                <div className="quantity">
                  <input
                    type="text"
                    id="odd_casino_web"
                    name="odd_casino_web"
                    value={placeBetObject.odds}
                  />
                  <div className="quantity-nav">
                    <div className="quantity-button quantity-up">
                      <span className="fa fa-caret-up"></span>
                    </div>
                    <div className="quantity-button quantity-down">
                      <span className="fa fa-caret-down"></span>
                    </div>
                  </div>
                </div>
              </td>
              <td width="10%">
                <div className="stake">
                  <input
                    type="text"
                    id="casino_amount_web"
                    onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                    onChange={(e) => getTypeAmount(e.target.value)}
                    value={defaultAmount}
                  />
                </div>
              </td>
              <td width="30%">
                <span
                  style={{
                    display: showBetfairProfitLossCalculation ? "" : "none"
                  }}
                >
                  <span id="web_profit_div_web">
                    <span id="span_profit_casino_web">{profit}</span>
                  </span>
                  <span id="span_profit_loss_gap">/ -</span>
                  <span id="mobile_lib_div_web">
                    <span id="span_liability_casino_web">{liability}</span>
                  </span>
                </span>
              </td>
            </tr>
            <tr
              className=" bgColorBetslip"
              style={{
                background:
                  placeBetObject.bettype === "b" ||
                  placeBetObject.bettype === "B"
                    ? "var(--theme-bg-color)"
                    : "#fce3e4"
              }}
            >
              <td colspan="5">
                <table
                  className="table"
                  style={{ backgroundColor: "transparent" }}
                >
                  <tbody>
                    <tr className="checknow">
                      <td>
                        <span
                          className="points stake_btn_web"
                          onClick={() => setStake(stake1)}
                        >
                          {stake1}
                        </span>
                      </td>
                      <td>
                        <span
                          className="points stake_btn_web"
                          onClick={() => setStake(stake2)}
                        >
                          {stake2}
                        </span>
                      </td>
                      <td>
                        <span
                          className="points stake_btn_web"
                          onClick={() => setStake(stake3)}
                        >
                          {stake3}
                        </span>
                      </td>
                      <td>
                        <span
                          className="points stake_btn_web"
                          onClick={() => setStake(stake4)}
                        >
                          {stake4}
                        </span>
                      </td>
                    </tr>
                    <tr className="checknow">
                      <td>
                        <span
                          className="points stake_btn_web"
                          onClick={() => setStake(stake5)}
                        >
                          +{stake5}
                        </span>
                      </td>
                      <td>
                        <span
                          className="points stake_btn_web"
                          onClick={() => setStake(stake6)}
                        >
                          +{stake6}
                        </span>
                      </td>
                      <td>
                        <span
                          className="points stake_btn_web"
                          onClick={() => setStake(stake7)}
                        >
                          +{stake7}
                        </span>
                      </td>
                      <td>
                        <span
                          className="points stake_btn_web"
                          onClick={() => setStake(stake8)}
                        >
                          +{stake8}
                        </span>
                      </td>
                    </tr>

                    <tr id="errorWebSlip">
                      <td colspan="6" className="alert-danger pr-5">
                        <span style={{ color: "red" }}>{betErrorMessage}</span>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <button
                          onClick={() => closeBetSlip()}
                          type="reset"
                          className="align-left btn btn-danger"
                          onclick="close_casino_betslip_web()"
                        >
                          <b>Close</b>
                        </button>
                      </td>
                      <td>
                        <button
                          onClick={() => clearStake()}
                          type="reset"
                          className="align-left btn btn-warning"
                          onclick="close_casino_betslip_web()"
                        >
                          <b>Clear</b>
                        </button>
                      </td>
                      <td colspan="1"></td>
                      <td>
                        <div
                          onClick={() => place_bet()}
                          className="btn btn-primary ld-over"
                          style={{
                            cursor: "pointer",
                            display: loading ? "none" : ""
                          }}
                          id="btn_place_bet_casino_web"
                          name="btn_place_bet_casino_web"
                        >
                          <b>Submit</b>
                          <div className="ld ld-ball ld-flip"></div>
                        </div>
                        <div
                          className="btn btn-primary ld-over running"
                          style={{
                            cursor: "pointer",
                            display: loading ? "" : "none"
                          }}
                          id="btn_place_bet_casino_web"
                          name="btn_place_bet_casino_web"
                        >
                          <b>Submit</b>
                          <div className="ld ld-ball ld-flip"></div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BetfairCasinoBetslipWeb;